import {z} from 'zod';

const objectIdPattern = /^[0-9a-f]{24}$/i;

export const objectIdStringSchema = z.string().regex(objectIdPattern);

export const agenticWorkflowIdSchema =
  objectIdStringSchema.brand<'AgenticWorkflowId'>();

export type AgenticWorkflowId = z.infer<typeof agenticWorkflowIdSchema>;

export const workflowDraftIdSchema =
  objectIdStringSchema.brand<'WorkflowDraftId'>();

export type WorkflowDraftId = z.infer<typeof workflowDraftIdSchema>;

export const workflowDraftMutationIdSchema = z
  .string()
  .uuid()
  .brand<'WorkflowDraftMutationId'>();

export type WorkflowDraftMutationId = z.infer<
  typeof workflowDraftMutationIdSchema
>;

export const workflowVersionSwitchExecutionLeaseTokenSchema = z
  .string()
  .uuid()
  .brand<'WorkflowVersionSwitchExecutionLeaseToken'>();

export type WorkflowVersionSwitchExecutionLeaseToken = z.infer<
  typeof workflowVersionSwitchExecutionLeaseTokenSchema
>;

export const workflowVersionSwitchFinalizationTokenSchema = z
  .string()
  .uuid()
  .brand<'WorkflowVersionSwitchFinalizationToken'>();

export type WorkflowVersionSwitchFinalizationToken = z.infer<
  typeof workflowVersionSwitchFinalizationTokenSchema
>;

export const workflowVersionIdSchema = z
  .number()
  .int()
  .positive()
  .brand<'WorkflowVersionId'>();

export type WorkflowVersionId = z.infer<typeof workflowVersionIdSchema>;

export const externalWorkflowIdSchema = z
  .string()
  .min(1)
  .brand<'ExternalWorkflowId'>();

export type ExternalWorkflowId = z.infer<typeof externalWorkflowIdSchema>;
